(function () {
  if (customElements.get('arq-megamenu')) return;

  class ArqMegamenu extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.arq-mm__toggle');
      this.drawer = this.querySelector('.arq-mm__drawer');
      this.overlay = this.querySelector('[data-arq-overlay]');
      if (!this.toggle || !this.drawer) return;

      this.divisions = Array.from(this.drawer.querySelectorAll('.arq-mm__division[data-target]'));
      this.panels = Array.from(this.drawer.querySelectorAll('.arq-mm__panel'));
      this.desktop = window.matchMedia('(min-width: 990px)');

      // Se mueve al <body> para que el header "sticky" no lo recorte.
      document.body.appendChild(this.overlay);
      document.body.appendChild(this.drawer);

      this.toggle.addEventListener('click', () => (this.isOpen() ? this.close() : this.open()));
      this.overlay.addEventListener('click', () => this.close());
      this.drawer.querySelectorAll('[data-arq-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      this.drawer.querySelectorAll('[data-arq-back]').forEach((b) => {
        b.addEventListener('click', () => this.showList());
        // Celular: barra superior del panel con «Volver» a la izquierda y ✕ (cerrar) a la derecha.
        const head = document.createElement('div');
        head.className = 'arq-mm__panel-head';
        b.parentNode.insertBefore(head, b);
        head.appendChild(b);
        const x = document.createElement('button');
        x.type = 'button';
        x.className = 'arq-mm__panel-close';
        x.setAttribute('aria-label', 'Cerrar menú');
        x.innerHTML = '<svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true"><path d="M1 1l16 16M17 1L1 17" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
        x.addEventListener('click', () => this.close());
        head.appendChild(x);
      });

      // Cada área: el nombre lleva a su página; la flecha (›) abre sus categorías.
      this.divisions.forEach((d) => {
        const banner = this.drawer.querySelector('#' + d.dataset.target + ' .arq-mm__banner');
        const href = banner ? banner.getAttribute('href') : '';
        const icon = d.querySelector('svg');
        if (icon) {
          const arrow = document.createElement('span');
          arrow.className = 'arq-mm__division-arrow';
          arrow.setAttribute('role', 'button');
          arrow.setAttribute('aria-label', 'Ver categorías de ' + d.textContent.trim());
          icon.parentNode.insertBefore(arrow, icon);
          arrow.appendChild(icon);
        }
        d.addEventListener('click', (e) => {
          const onArrow = e.target.closest('.arq-mm__division-arrow');
          if (!onArrow && href && href !== '#') {
            window.location.href = href;
            return;
          }
          this.activate(d, true);
        });
        d.addEventListener('mouseenter', () => {
          if (!this.desktop.matches) return;
          clearTimeout(this.hoverTimer);
          this.hoverTimer = setTimeout(() => this.activate(d, false), 120);
        });
        d.addEventListener('mouseleave', () => clearTimeout(this.hoverTimer));
      });

      this.setupQuickLinks();
      this.setupMobile();
      this.setupSticky();

      this.onKey = (e) => {
        if (e.key === 'Escape' && this.isOpen()) this.close();
      };
      document.addEventListener('keydown', this.onKey);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKey);
      if (this.onStickyChange) {
        window.removeEventListener('scroll', this.onStickyChange);
        window.removeEventListener('resize', this.onStickyChange);
      }
      document.documentElement.classList.remove('arq-mm-lock');
      if (this.drawer) this.drawer.remove();
      if (this.overlay) this.overlay.remove();
    }

    // "Estás aquí": marca el área actual (su página o una de sus categorías) en esta barra
    // o, si no está en ella, en el menú del header (ej.: ECOMMERCE).
    setupQuickLinks() {
      const path = (href) => {
        try { return new URL(href, location.origin).pathname.replace(/\/+$/, '') || '/'; } catch (e) { return ''; }
      };
      const current = this.findCurrent(true);
      if (!current) return;
      const banner = this.drawer.querySelector('#' + current.dataset.target + ' .arq-mm__banner');
      if (!banner) return;
      const links = Array.from(this.querySelectorAll('.arq-mm__feature, .arq-mm__quick a[href]'))
        .concat(Array.from(document.querySelectorAll('.header__inline-menu a[href]')));
      const a = links.find((l) => path(l.href) === path(banner.href));
      if (!a) return;
      a.classList.add('arq-mm__here');
      a.setAttribute('aria-current', 'page');

      // Si el área no está en esta barra (ej.: ECOMMERCE, que va en el header), la barra muestra
      // las categorías de esa área en vez de las áreas de negocio, para no confundirlas.
      const quick = this.querySelector('.arq-mm__quick');
      if (!quick || quick.contains(a)) return;
      const panel = this.drawer.querySelector('#' + current.dataset.target);
      const cats = panel ? Array.from(panel.querySelectorAll('.arq-mm__l1 a[href]')) : [];
      if (!cats.length) return;
      quick.innerHTML = '';
      const label = document.createElement('a');
      label.className = 'arq-mm__quick-label';
      label.href = banner.getAttribute('href');
      label.textContent = current.textContent.trim();
      quick.appendChild(label);
      cats.forEach((c) => {
        const link = document.createElement('a');
        link.href = c.getAttribute('href');
        link.textContent = c.textContent.replace(/NUEVO$/, '').trim();
        if (path(link.href) === path(location.href)) {
          link.classList.add('arq-mm__here');
          link.setAttribute('aria-current', 'page');
        }
        quick.appendChild(link);
      });
      this.classList.add('arq-mm--context');
    }

    // Celular / tablet (estilo Falabella): ☰ a la izquierda del logo y buscador ancho bajo el header.
    setupMobile() {
      const header = document.querySelector('header.header');
      if (header && !header.querySelector('.arq-mm__burger-btn')) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'arq-mm__burger-btn';
        btn.setAttribute('aria-label', 'Abrir menú');
        btn.innerHTML = '<span class="arq-mm__burger" aria-hidden="true"><span></span><span></span><span></span></span>';
        btn.addEventListener('click', () => (this.isOpen() ? this.close() : this.open()));
        header.insertBefore(btn, header.firstChild);
        this.mobileToggle = btn;
      }
      const bar = this.querySelector('.arq-mm__bar');
      if (bar && !bar.querySelector('.arq-mm__search')) {
        const form = document.createElement('form');
        form.className = 'arq-mm__search';
        form.action = '/search';
        form.method = 'get';
        form.setAttribute('role', 'search');
        form.innerHTML =
          '<input type="search" name="q" placeholder="Buscar en Arquimed" aria-label="Buscar en Arquimed" autocomplete="off">' +
          '<button type="submit" aria-label="Buscar"><svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true"><circle cx="8.5" cy="8.5" r="6.5" fill="none" stroke="currentColor" stroke-width="2"/><path d="M13.5 13.5L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>';
        bar.appendChild(form);
      }
    }

    // Barra fija bajo el header (que se oculta al bajar y reaparece al subir).
    setupSticky() {
      this.section = this.closest('.shopify-section');
      if (!this.section) return;
      this.headerSection = document.querySelector('.section-header');
      this.section.style.position = 'sticky';
      // Sobre la barra de las landings (z 999) y bajo el header (para sus desplegables).
      this.section.style.zIndex = '1001';
      if (this.headerSection) this.headerSection.style.zIndex = '1002';

      this.loopUntil = 0;
      const loop = () => {
        this.updateSticky();
        if (performance.now() < this.loopUntil) {
          this.raf = requestAnimationFrame(loop);
        } else {
          this.raf = null;
        }
      };
      this.onStickyChange = () => {
        this.loopUntil = performance.now() + 450;
        if (!this.raf) this.raf = requestAnimationFrame(loop);
      };
      window.addEventListener('scroll', this.onStickyChange, { passive: true });
      window.addEventListener('resize', this.onStickyChange);
      window.addEventListener('load', this.onStickyChange);
      document.addEventListener('DOMContentLoaded', this.onStickyChange);
      this.updateSticky();
    }

    updateSticky() {
      const hb = this.headerSection ? Math.max(0, Math.round(this.headerSection.getBoundingClientRect().bottom)) : 0;
      this.section.style.top = hb + 'px';
      // Barra de categorías de cada landing (sections/menu-landing): cuando queda fija,
      // va justo bajo esta barra y el contenido se corre para que no lo tape.
      const landing = document.querySelector('.menu-landing');
      if (!landing) return;
      const main = document.getElementById('MainContent');
      if (getComputedStyle(landing).position === 'fixed') {
        landing.style.top = hb + this.section.offsetHeight + 'px';
        landing.style.setProperty('margin-top', '0px', 'important');
        if (main) main.style.paddingTop = landing.offsetHeight + 'px';
      } else {
        landing.style.removeProperty('margin-top');
        if (main) main.style.paddingTop = '';
      }
    }

    isOpen() {
      return this.drawer.classList.contains('is-open');
    }

    open(division) {
      clearTimeout(this.closeTimer);
      this.drawer.classList.remove('is-closing');
      this.drawer.classList.add('no-anim');
      this.drawer.querySelectorAll('.arq-mm__divisions > li').forEach((li, i) => li.style.setProperty('--i', i));
      this.drawer.hidden = false;
      this.overlay.hidden = false;
      void this.drawer.offsetWidth; // aplica la posición inicial para que la animación corra
      this.toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('arq-mm-lock');
      const current = division || this.findCurrent(true);
      if (current) {
        this.activate(current, true);
      } else if (this.desktop.matches && this.divisions[0]) {
        this.activate(this.divisions[0], false);
      } else {
        this.showList();
      }
      void this.drawer.offsetWidth;
      this.drawer.classList.remove('no-anim');
      this.drawer.classList.add('is-open');
      this.overlay.classList.add('is-open');
      const closeBtn = this.drawer.querySelector('.arq-mm__close');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }

    // División de la página actual: su landing o un enlace dentro de su panel (si no, ninguna).
    findCurrent(strict) {
      const norm = (href) => {
        try { return new URL(href, location.origin).pathname.replace(/\/+$/, '') || '/'; } catch (e) { return ''; }
      };
      const path = norm(location.href);
      this.drawer.querySelectorAll('.is-current').forEach((a) => a.classList.remove('is-current'));
      if (path !== '/') {
        for (const d of this.divisions) {
          const banner = this.drawer.querySelector('#' + d.dataset.target + ' .arq-mm__banner');
          if (banner && norm(banner.href) === path) return d;
        }
        for (const d of this.divisions) {
          const panel = this.drawer.querySelector('#' + d.dataset.target);
          const hit = panel && Array.from(panel.querySelectorAll('a[href]')).find((a) => !a.classList.contains('arq-mm__banner') && norm(a.href) === path);
          if (hit) { hit.classList.add('is-current'); return d; }
        }
      }
      return null;
    }

    close() {
      (this.carets || []).forEach((c) => c.setAttribute('aria-expanded', 'false'));
      this.drawer.classList.add('is-closing');
      this.drawer.classList.remove('is-open');
      this.overlay.classList.remove('is-open');
      this.toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('arq-mm-lock');
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => {
        if (this.isOpen()) return;
        this.drawer.classList.add('no-anim');
        this.drawer.classList.remove('show-panel', 'is-closing');
        this.drawer.hidden = true;
        this.overlay.hidden = true;
        this.drawer.classList.remove('no-anim');
      }, 320);
      const back = this.desktop.matches ? this.toggle : (this.mobileToggle || this.toggle);
      back.focus({ preventScroll: true });
    }

    activate(division, fromClick) {
      this.divisions.forEach((d) => {
        const on = d === division;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      this.panels.forEach((p) => {
        p.hidden = p.id !== division.dataset.target;
      });
      this.drawer.classList.add('has-panel');
      if (!this.desktop.matches || fromClick) this.drawer.classList.add('show-panel');
      const panels = this.drawer.querySelector('.arq-mm__panels');
      if (panels) panels.scrollTop = 0;
      const active = this.drawer.querySelector('#' + division.dataset.target);
      if (active) active.scrollTop = 0;
    }

    showList() {
      this.drawer.classList.remove('show-panel');
      if (!this.desktop.matches) {
        this.divisions.forEach((d) => {
          d.classList.remove('is-active');
          d.setAttribute('aria-expanded', 'false');
        });
      }
    }
  }

  customElements.define('arq-megamenu', ArqMegamenu);
})();
